import {createSelector} from '@store/@common';

import LibraryCreateFormStore from 'stores/library/LibraryCreateFormStore';

export const libraryCreateForm = createSelector(LibraryCreateFormStore as any);
